class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this.dialogComponent = null; 
    this.addEventListener('click', e => this.init(e));
  }

  connectedCallback() {
    const dialogElement = document.getElementById('swymModal');
    if (dialogElement) {
      this.dialogComponent = dialogElement.closest('dialog-component');
    }
  }

  async init(e) {
    const { productHandle } = e.target.dataset;
    const modal = document.querySelector('#swymModal');
    console.log(modal)
    if (!productHandle) return;

    try {
      const res = await fetch(`/products/${productHandle}.js`);
      const data = await res.json();
      if (!res.ok) throw new Error('Failed to fetch product data');
      this.renderMarkup(data);
      if (this.dialogComponent) {
        this.dialogComponent.showDialog(e);
      }
    } catch (error) {
      console.error(error);
    }
  }

  renderMarkup(data) {
    const {
      available,
      url,
      title,
      featured_image,
      variants,
    } = data;

    const container = document.getElementById('SWYMCustomModal-Content');
    container.innerHTML = ''; // clear previous

    const renderVariants = variants.map(({ id, title }) => `<option value="${id}">${title}</option>`).join('');

    if (available && variants.length === 1) {
      container.innerHTML = `
        <div class="product-content">
          <a href="${url}">
            <img src="${featured_image}" alt="${title}" />
            <span>${title}</span>
          </a>
        </div>
        <div class="message hide">Product added to wishlist!</div>
      `;
      this.addToWishlist(data, container);
    } else {
      container.innerHTML = `
        <div class="product-content">
          <a href="${url}">
            <img src="${featured_image}" alt="${title}" />
            <span class="h5">${title}</span>
          </a>
          <div class="variants">
            <label for="variants" hidden>Select an option</label>
            <select id="variants" class="wishlist-variants" name="variants">${renderVariants}</select>
          </div>
          <button type="button" class="button button--primary button--full js-add-to-wishlist">Add to wishlist</button>
        </div>
      `;

      container.querySelector('.js-add-to-wishlist')
        .addEventListener('click', () => this.addToWishlist(data, container));
    }
  }

  async addToWishlist(data, container) {
    if (!data || !container) return;

    const {
      title,
      price,
      url,
      featured_image,
      variants,
      id: productId,
    } = data;

    const shopUrl = Theme.routes.shop_url;

    const wishList = await new Promise(resolve => window._swat.fetch(r => resolve(r)));

    const message = container.querySelector('.message');
    const button = container.querySelector('.js-add-to-wishlist');
    let variantId;

    if (variants.length === 1) {
      variantId = variants[0].id;
    } else {
      const select = container.querySelector('[name="variants"]');
      variantId = select ? select.value : null;
    }

    if (!variantId) {
      console.log('No variant id found');
      return;
    }

    const alreadyInWishlist = wishList.find(item => item.epi === +variantId);

    if (!alreadyInWishlist) {
      if (button) button.classList.add('button--loading');

      const obj = {
        epi: +variantId,
        empi: +productId,
        du: `${shopUrl}${url}`,
        iu: featured_image,
        pr: price,
      };

      const callback = async () => {
        if (button) {
          button.innerHTML = 'Product added!';
          button.classList.remove('btn--loading');
        }
        if (message) message.classList.remove('hide');

        if (this.dialogComponent) {
          await new Promise(resolve => setTimeout(resolve, 2500));
          this.dialogComponent.closeDialog();
        } else {
          document.getElementById('SWYMCustomModal').close();
        }
      };

      window._swat.addToWishList(obj, callback);
    } else {
      console.log('Item already in wishlist');
      const select = container.querySelector('[name="variants"]');
      if (select) {
        select.setCustomValidity('Product already in wishlist');
        select.reportValidity();
      }
      if (message) {
        message.innerText = 'Product already in wishlist';
        message.classList.remove('hide');
      }
    }
  }
}

customElements.define('wishlist-button', WishlistButton);